import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import InputField from "components/form/InputField";
import DateField from "components/form/DateField";
import FormActionButtons from "components/Button/FormActionButtons";
import AlertDialog from "components/Feedback/AlertDialog";
import { updateCooperativeMember } from "services/CooperativeMemberServices";

const EditAnggotaKoperasi = () => {
  const navigate = useNavigate();
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  const {
    handleSubmit,
    control,
    reset,
    register,
    formState: { errors },
  } = useForm();

  // data yang dipilih saat klik edit
  const stored = React.useMemo(() => {
    return JSON.parse(localStorage.getItem("editAnggotaKoperasi") || "{}");
  }, []);

  useEffect(() => {
    if (!stored || !stored.id) {
      alert("Data anggota tidak ditemukan.");
      navigate("/anggota-koperasi"); // cek lagi route utama kamu
      return;
    }

    // reset form dengan data existing
    reset({
      joinDate: stored.joinDate || "",
    });
  }, [navigate, reset]); // ✅ stored dihapus dari dependency

  const onSubmit = async (formData) => {
    try {
      const payload = {
        userId: stored.userId,
        memberId: stored.memberId,
        joinDate: formData.joinDate?.split("T")[0] || stored.joinDate,
      };

      console.log("Payload update:", payload);
      console.log("Form value joinDate:", formData.joinDate);

      await updateCooperativeMember(stored.id, payload);
      setIsAlertOpen(true);
    } catch (err) {
      console.error("Gagal update anggota:", err.response?.data || err);
      alert("Terjadi kesalahan saat memperbarui data.");
    }
  };

  return (
    <div className="pl-64 mt-8">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="max-w-3xl p-6 mx-auto bg-white border border-gray-200 shadow-lg rounded-2xl"
      >
        <h2 className="mb-6 text-xl font-semibold text-center text-green-700 sm:text-xl">
          Edit Anggota Koperasi
        </h2>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {/* Nama (readonly) */}
          <InputField label="Nama" value={stored.nama || "-"} readOnly />

          {/* Kelompok/Status (readonly) */}
          <InputField label="Kelompok" value={stored.status || "-"} readOnly />

          {/* Member ID (readonly) */}
          <InputField
            label="Member ID"
            value={stored.memberId || "-"}
            readOnly
          />

          {/* Join Date */}
          <DateField
            label="Join Date"
            type="date"
            {...register("joinDate", { required: "Join Date wajib diisi" })}
            error={errors.joinDate}
          />
        </div>

        <FormActionButtons
          submitLabel="Update"
          cancelLabel="Batal"
          onCancel={() => navigate("/anggota-koperasi")} // pastikan route sesuai
          className="mt-8"
        />
      </form>

      {isAlertOpen && (
        <AlertDialog
          isOpen={isAlertOpen}
          onClose={() => {
            setIsAlertOpen(false);
            localStorage.removeItem("editAnggotaKoperasi");
            navigate("/anggota-koperasi"); // sama seperti cancel
          }}
          title="Berhasil"
          message="Data anggota berhasil diperbarui!"
        />
      )}
    </div>
  );
};

export default EditAnggotaKoperasi;
